import axiosInstance from '../axiosInstance.js'

export default {
  me(token) {
    return axiosInstance.get('/profile', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
  },

  uploadFile({ token, file }) {
    return axiosInstance.post('/artists/profile-pictures/uploads', file, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data; charset=utf-8'
      },
      onUploadProgress: (uploadEvent) => {
        // eslint-disable-next-line no-console
        console.log(
          'Upload progress: ' +
            Math.round((uploadEvent.loaded / uploadEvent.total) * 100) +
            '%'
        )
      }
    })
  },

  updateProfilePicture({ token, userId, file }) {
    return axiosInstance.post(`/profile/${userId}/avatar`, file, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data; charset=utf-8'
      },
      onUploadProgress: (uploadEvent) => {
        // eslint-disable-next-line no-console
        console.log(
          'Upload progress: ' +
            Math.round((uploadEvent.loaded / uploadEvent.total) * 100) +
            '%'
        )
      }
    })

    // return axiosInstance.put(`/profile/${userId}/avatar`, {
    // 	'profile_picture': iri
    // },
    // {
    // 	headers: {
    // 		Authorization: `Bearer ${token}`
    // 	}
    // })
  },

  getProfilePicture({ token, fileId }) {
    return axiosInstance.get(`/files/${fileId}/content`, {
      responseType: 'arraybuffer',
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
  },

  setNewPassword({ token, payload }) {
    return axiosInstance.patch(
      '/profile/change-password',
      {
        ...payload
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/merge-patch+json'
        }
      }
    )
  },

  editProfile({ token, profilePayload }) {
    return axiosInstance.put('/profile', profilePayload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
  }
}
